export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const NUM_FORMAT = 4;

// config TESTNET
// export const RPC_BASE = "https://sepolia.base.org"
// export const BASE_SCAN = "https://sepolia.basescan.org"
// export cont WORK_sCHAIN = 84532

// // config MAINNET
// export const RPC_BASE = "https://light-fluent-sound.base-mainnet.quiknode.pro/b3c14bfd234f7c92338dd0b260f1df387ee575ca/"
// // "https://proud-silent-sky.base-mainnet.quiknode.pro/ff3f057f7dec2c8b28e9c15442aa037893b40969/"
// export const BASE_SCAN = "https://basescan.org"
// export const WORK_CHAIN = 8453

export const RPC_BASE = process.env.REACT_APP_RPC_URL;

export const BASE_SCAN = process.env.REACT_APP_SCAN_URL;
export const WORK_CHAIN = +Number(process.env.REACT_APP_CHAIN_ID || 1155111);

export const TELE_URL = 'https://t.me/Mey_Network';
export const TELE_GROUP_URL = 'https://t.me/MeyNetwork';
export const FB_URL = 'https://www.facebook.com/MeyNetwork';
export const X_URL = 'https://x.com/Mey_Network';
export const YT_URL = 'https://www.youtube.com/@MeyNetwork';

export const ENABLE_VESTING_HMC =
  process.env.REACT_APP_ENABLE_VESTING_HMC === 'true';

export const BASE_PATH = process.env.REACT_APP_BASE_PATH || '/';

export const BASE_PATH_LIGHTMODE = process.env.REACT_APP_BASE_PATH_LIGHTMODE || 'https://meyfi.io';

export const ENABLE_LANDING_PAGE =
  process.env.REACT_APP_ENABLE_LANDING_PAGE === 'true';

export const ENABLE_VESTING_VENTURE =
  process.env.REACT_APP_ENABLE_VESTING_VENTURE === 'true';

export const ENABLE_TESTNET = process.env.REACT_APP_ENABLE_TESTNET === 'true';

/**
 * V2 staking-token portfolio page, mapped per environment by the deploy host.
 * dev -> meyfi.meey.dev, staging -> meyfi-staging.meey.dev, prod -> meyfi.io.
 * Falls back to the dev URL (e.g. on localhost).
 */
export const STAKING_PORTFOLIO_URL = (() => {
  const host =
    typeof window !== 'undefined' ? window.location.hostname : '';
  if (host.includes('staging'))
    return 'https://meyfi-staging.meey.dev/staking-token/portfolio';
  if (host.includes('meyfi.io'))
    return 'https://meyfi.io/staking-token/portfolio';
  return 'https://meyfi.meey.dev/staking-token/portfolio';
})();
